import { QueryView } from '@ui/utils/async-view/QueryView';
import { Link } from 'react-router-dom';
import { useFragmentQuery } from '../hooks/useFragment';

export function FragmentLink({ id }: { id: string }) {
  const query = useFragmentQuery(id);

  return (
    <QueryView inline query={query}>
      {(data) => <Link to={`/fragments/${id}`}>{data.title}</Link>}
    </QueryView>
  );
}
